import { useQueryClient } from '@tanstack/react-query'

import { apiPost } from '../config'
import { API_ROUTES } from '../routes'
import { useMutationHook } from './mutationHook'

interface ICreateAgreementResponse {
  message: string
  data: string
}

interface ICreateAgreementParams {
  authorPhone: string
  typeId: string
  substitutions?: {
    [key: string]: string
  }
  products?: string[]
}

async function fetchCreateAgreement(path: string, body: ICreateAgreementParams) {
  const { data } = await apiPost<ICreateAgreementParams, ICreateAgreementResponse>({ path, body })

  return data
}

export const useCreateAgreement = (options?: {
  onSuccess?: (data: ICreateAgreementResponse) => void
  onError?: (error: Error) => void
}) => {
  const queryClient = useQueryClient()
  const path = API_ROUTES.AGREEMENT_CREATE
  const mutationFn = (url: string, body: ICreateAgreementParams) => fetchCreateAgreement(url, body)

  return useMutationHook({
    path,
    mutationKey: [path],
    mutationFn,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [API_ROUTES.AGREEMENTS],
      })
      queryClient.invalidateQueries({
        queryKey: [API_ROUTES.AUTHORS],
      })
      options?.onSuccess?.(data)
    },
    onError: options?.onError,
  })
}
